import { Injectable } from '@angular/core';
import { TranslateService } from 'ng2-translate';
import { Observable } from 'rxjs/Observable';
import { DistributionStatus } from '../../domain/enums/distribution-status';
import { SectorOverviewItem, Address, Street } from '../../domain/models';
import { Distribution } from '../../domain/models/distribution/distribution';
import { DistributionDomainService } from '../../domain/services/distribution/distribution.domain.service';
import { SectorDomainService } from '../../domain/services/sector/sector.domain.service';
import { DistributionViewModel } from '../view-models/distribution.view-model';
import { StopDistributionReasonDto } from '../../domain/models/stop-distribution-reason-dto';
import { TrackingData } from '../../domain/models/tracking/tracking_data';

@Injectable()
export class DistributionDetailService {

    constructor(
        private distributionDomainService: DistributionDomainService,
        private sectorDomainService: SectorDomainService,
        private translate: TranslateService) {
    }

    public getDistributionDetailById(distributionId: string): Observable<DistributionViewModel> {
        return this.distributionDomainService.getDistributionDetailById(distributionId).switchMap((distribution: Distribution) => {
            const sectorIds: string[] = [distribution.sectorId];
            return this.sectorDomainService.getSectorOverviewByIds(sectorIds);
        }, ((distribution: Distribution, sectorOverview: SectorOverviewItem[]): DistributionViewModel => {
            const sectorOverviewItem: SectorOverviewItem = sectorOverview.length > 0 ? sectorOverview[0] : null;
            return new DistributionViewModel(distribution, sectorOverviewItem, this.getStatusTextForStatus(distribution.status));
        }));
    }

    getTrackingData(distributionId: string): Observable<TrackingData> {
        return this.distributionDomainService.getTrackingData(distributionId);
    }

    public getAddressBySectorId(sectorId: string): Observable<Address[]> {
        return this.sectorDomainService.getAddressesBySectorId(sectorId);
    }
    public getStreetsBySectorId(sectorId: string): Observable<Street[]> {
        return this.sectorDomainService.getStreetsBySectoriD(sectorId);
    }

    public startDistribution(distributionId: string): Observable<any> {
        return this.distributionDomainService.startDistribution(distributionId);
    }

    public stopDistribution(stopDistributionReasonDto: StopDistributionReasonDto): Observable<any> {
        return this.distributionDomainService.stopDistribution(stopDistributionReasonDto);
    }

    private getStatusTextForStatus(status: DistributionStatus): string {
        let statusText: string = '';
        switch (status) {
            case DistributionStatus.Initialized:
                statusText = this.translate.instant('INITIALIZED');
                break;
            case DistributionStatus.Registering:
                statusText = this.translate.instant('STARTED');
                break;
            case DistributionStatus.Completed:
                statusText = this.translate.instant('STOPPED');
                break;
        }
        return statusText;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/distribution/services/distribution-detail.service.ts